<!-- Notification Toast -->
<div *ngIf="showCartNotification" 
     class="notification-toast" 
     [ngClass]="'notification-' + notificationType">
  <div class="notification-content">
    <span class="notification-icon">
      <i [ngClass]="notificationType === 'success' ? 'fas fa-check-circle' : 
                     (notificationType === 'error' ? 'fas fa-times-circle' : 'fas fa-exclamation-circle')"></i>
    </span>
    <span class="notification-message">{{ notificationMessage }}</span>
    <button class="notification-close" (click)="showCartNotification = false">
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>



<!-- Loading State -->
<div *ngIf="isLoading" class="divsubscription bg-white px-3 py-5">


      <div>
        <div class="text-center pt-5 pb-5">
          <div class="loader loader--style8" title="7">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
              <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
              </rect>
              <rect x="8" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
              </rect>
              <rect x="16" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
              </rect>
            </svg>
          </div>
        </div>  
      </div>   

</div>

<!-- Error State -->
<div *ngIf="loadingError && !isLoading" class="divsubscription bg-white px-3 py-5">
  <div class="container">
    <div class="alert alert-danger" role="alert">
      <h4 class="alert-heading">{{ 'common.error' | translate }}</h4>
      <p>{{ 'subscription_products.error_loading' | translate }}</p>
      <hr>
      <button (click)="loadProducts()" class="btn btn-primary">{{ 'common.retry' | translate }}</button>
    </div>
  </div>
</div>

<!-- Products View -->
<div *ngIf="!isLoading && !loadingError" class="">


  <div class="container pb-5">

    <div class="mb-3">
      <app-breadcrumb 
              returnAction="/dashboard" 
              [breadcrumbs]="[
                  { label: 'Company Management', url: '/setting/company-management' },
                  { label: 'Daftar Paket' }
              ]"
      >
      </app-breadcrumb>
    </div> 
    <div class="card border-0 mb-3">
      <div class="row">
          <div class="col-sm-12">
              <div class="cd-title">Daftar Paket</div>
          </div>
      </div>
    </div>

    <div class="card border-0 mb-3">
      <div class="cd-content px-3 py-2">

        <div class=" divsubscription pb-3">
          <div class="row g-0 justify-content-center pb-3 pb-lg-5">

            <div class="col-12">

              <!-- Stepper Navigation -->
              <div>
                <nav class="d-flex flex-wrap text-center nav mt-sm-3 mt-lg-1">
                  <li class="flex-fill nav-item nav-rfq px-0 pt-2 active-link">
                    <a class="nav-link mn-color border-bottom border1 border-2">
                      <i class="fas fa-shopping-bag me-2"></i>Langkah 1 (Pilih Paket)
                    </a>
                  </li>
                  <li class="flex-fill nav-item nav-rfq px-0 pt-2" [ngClass]="{'disabled-link': cartItems.length === 0}">
                    <a class="nav-link mn-color" 
                      (click)="goToCart()" 
                      [class.opacity-50]="cartItems.length === 0"
                      [style.cursor]="cartItems.length === 0 ? 'not-allowed' : 'pointer'">
                      <i class="fas fa-cart-shopping me-2"></i>Langkah 2 (Pesanan)
                    </a>
                  </li>
                  <li class="flex-fill nav-item nav-rfq px-0 pt-2">
                    <a class="nav-link mn-color">
                      <i class="fas fa-credit-card me-2"></i>Langkah 3 (Konfirmasi Pesanan)
                    </a>
                  </li>
                </nav>
              </div>



            </div>


            <!-- Offered Subscriptions Section -->
            <div class="col-12" *ngIf="offeredSubscription && offeredSubscription.length > 0">
              <h2 class="text-center my-5">{{ 'subscription_products.offered_subscriptions' | translate }}</h2>
              <div class="row g-4 justify-content-center">
                <div *ngFor="let subscription of offeredSubscription" class="col-12 col-sm-6 col-lg-4 pricing-card">
                  <div class="package-card">
                    <!-- Discount Badge -->
                    <svg *ngIf="subscription.subscriptionDiscount > 0" class="discount-badge" viewBox="-1 -1 50 50" width="80px" height="80px">
                      <path d="M 35,40 30,48 21,42 11,44 9,34 0,30 6,20 4,10 14,8 20,0 28,5 38,3 l 1,10 8,5 -5,8 2,10z" fill="#eef4ae" />
                      <text x="25" y="25" text-anchor="middle" dy=".3em" class="badge-text">-{{ ((subscription.subscriptionDiscount / subscription.subscriptionPrice) * 100) | number:'1.0-0' }}%</text>
                    </svg>

                    <div class="card-header">
                      <h4 class="card-title">{{ subscription.subscriptionName }}</h4>
                    </div>
                    
                    <div class="card-pricing">
                      <div class="price-section">
                        <small *ngIf="subscription.subscriptionDiscount > 0" class="original-price">
                          {{ subscription.subscriptionPrice | number:'1.2-2' }}
                        </small>
                        <span class="price">{{ subscription.currency }} {{ (subscription.subscriptionPrice - subscription.subscriptionDiscount) | number:'1.2-2' }}<font class="currency"> / {{ subscription.expiredInDays }} {{ 'common.days' | translate }}</font></span>
                        
                      </div>
                    </div>

                    <div class="card-body p-0">
                      <div class="features-list">
                        <div *ngFor="let feature of subscription.subscriptionFeature" class="feature-item">
                          
                          <div class="feature-content">
                            <p class="feature-name">{{ feature.featureName }} <font class="fas fa-lock feature-lock"></font></p>
                            <small class="text-muted d-block" *ngIf="feature.featureDesc">{{ feature.featureDesc }}</small>
                            <small class="text-muted d-block" *ngIf="feature.featureAvailableQty">
                              {{ 'subscription_products.qty_available' | translate }}: {{ feature.featureAvailableQty }}
                            </small>
                            
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer text-center" *ngIf="subscription.isCurrent">
                        <span *ngIf="subscription.isCurrent" class="badge bgsuccess">Paket Aktif Saat Ini</span>
                    </div>
                    <div class="card-footer" *ngIf="!subscription.isCurrent">
                      <button 
                        (click)="addToCartSubscription(subscription, 'subscription')" 
                        [ngClass]="getSubscriptionButtonClass(subscription.fhProductOfferingId)"
                        class="btn w-100 subscribe-btn">
                        <span *ngIf="!isProductInCart(subscription.fhProductOfferingId, 'subscription')">
                          <i class="fas fa-shopping-cart me-2"></i>{{ getSubscriptionButtonLabel(subscription.fhProductOfferingId) | translate }}
                        </span>
                        <span *ngIf="isProductInCart(subscription.fhProductOfferingId, 'subscription')">
                          <i class="fas fa-trash me-2"></i>{{ 'common.remove' | translate }}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Offered Add-ons Section -->
            <div class="col-12" *ngIf="offeredAddOn && offeredAddOn.length > 0">
              <h2 class="text-center mb-5 mt-5">{{ 'subscription_products.offered_addons' | translate }}</h2>
              <div class="row g-4 justify-content-center">
                <div *ngFor="let addon of offeredAddOn" class="col-12 col-sm-6 col-lg-4 pricing-card">
                  <div class="package-card">
                    <!-- Discount Badge -->
                    <svg *ngIf="addon.addOnDiscount > 0" class="discount-badge" viewBox="-1 -1 50 50" width="80px" height="80px">
                      <path d="M 35,40 30,48 21,42 11,44 9,34 0,30 6,20 4,10 14,8 20,0 28,5 38,3 l 1,10 8,5 -5,8 2,10z" fill="#eef4ae" />
                      <text x="25" y="25" text-anchor="middle" dy=".3em" class="badge-text">-{{ ((addon.addOnDiscount / addon.addOnPrice) * 100) | number:'1.0-0' }}%</text>
                    </svg>

                    <div class="card-header">
                      <h4 class="card-title">{{ addon.addOnName }}</h4>
                    </div>

                    <div class="card-pricing">
                      <div class="price-section">
                        <small *ngIf="addon.addOnDiscount > 0" class="original-price">
                          {{ addon.addOnPrice | number:'1.2-2' }}
                        </small>
                        <span class="price">{{ addon.currency }} {{ (addon.addOnPrice - addon.addOnDiscount) | number:'1.2-2' }} <font class="currency"> / {{ addon.expiredInDays }} {{ 'common.days' | translate }}</font></span>
                        
                      </div>
                    </div>

                    <div class="card-body">
                      <div class="addon-info">
                        <small class="text-muted d-block">
                          {{ 'subscription_products.expires_in' | translate }}: {{ addon.expiredInDays }} {{ 'common.days' | translate }}
                        </small>
                        <small class="text-muted d-block">
                          {{ 'subscription_products.qty_offered' | translate }}: {{ addon.qtyOffered }}
                        </small>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button 
                        (click)="addToCartSubscription(addon, 'addon')" 
                        [ngClass]="!isProductInCart(addon.fhProductOfferingId, 'addon') ? 'btn-primary' : 'btn-danger'"
                        class="btn w-100 subscribe-btn">
                        <span *ngIf="!isProductInCart(addon.fhProductOfferingId, 'addon')">
                          <i class="fas fa-shopping-cart me-2"></i>{{ 'subscription_products.add_to_cart' | translate }}
                        </span>
                        <span *ngIf="isProductInCart(addon.fhProductOfferingId, 'addon')">
                          <i class="fas fa-trash me-2"></i>{{ 'common.remove' | translate }}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Offered Vouchers Section -->
            <div class="col-12" *ngIf="offeredVoucher && offeredVoucher.length > 0">
              <h2 class="text-center mb-5 mt-5">{{ 'subscription_products.offered_vouchers' | translate }}</h2>
              <div class="row g-4 justify-content-center">
                <div *ngFor="let voucher of offeredVoucher" class="col-12 col-sm-6 col-lg-4 pricing-card">
                  <div class="package-card">
                    <!-- Discount Badge -->
                    <svg *ngIf="voucher.voucherDiscount > 0" class="discount-badge" viewBox="-1 -1 50 50" width="80px" height="80px">
                      <path d="M 35,40 30,48 21,42 11,44 9,34 0,30 6,20 4,10 14,8 20,0 28,5 38,3 l 1,10 8,5 -5,8 2,10z" fill="#eef4ae" />
                      <text x="25" y="32" text-anchor="middle" dy=".3em" class="badge-text">-{{ ((voucher.voucherDiscount / voucher.voucherPrice) * 100) | number:'1.0-0' }}%</text>
                    </svg>

                    <div class="card-header">
                      <h4 class="card-title">{{ voucher.voucherName }}</h4>
                    </div>

                    <div class="card-pricing">
                      <div class="price-section">
                        <small *ngIf="voucher.voucherDiscount > 0" class="original-price">
                          {{ voucher.voucherPrice | number:'1.2-2' }}
                        </small>
                        <span class="price">{{ voucher.currency }} {{ (voucher.voucherPrice - voucher.voucherDiscount) | number:'1.2-2' }}<font class="currency"> / {{ voucher.expiredInDays }} {{ 'common.days' | translate }}</font></span>
                        
                      </div>
                    </div>

                    <div class="card-body">
                      <div class="voucher-info">
                        <small class="text-muted d-block">
                          {{ 'subscription_products.expires_in' | translate }}: {{ voucher.expiredInDays }} {{ 'common.days' | translate }}
                        </small>
                        <small class="text-muted d-block">
                          {{ 'subscription_products.credit_offered' | translate }}: {{ voucher.creditOffered }} {{ voucher.currency }}
                        </small>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button 
                        (click)="addToCartSubscription(voucher, 'voucher')" 
                        [ngClass]="!isProductInCart(voucher.fhProductOfferingId, 'voucher') ? 'btn-primary' : 'btn-danger'"
                        class="btn w-100 subscribe-btn">
                        <span *ngIf="!isProductInCart(voucher.fhProductOfferingId, 'voucher')">
                          <i class="fas fa-shopping-cart me-2"></i>{{ 'subscription_products.add_to_cart' | translate }}
                        </span>
                        <span *ngIf="isProductInCart(voucher.fhProductOfferingId, 'voucher')">
                          <i class="fas fa-trash me-2"></i>{{ 'common.remove' | translate }}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="offeredSubscription.length === 0 && offeredAddOn.length === 0 && offeredVoucher.length === 0" class="col-12">
              <div class="alert alert-info text-center" role="alert">
                <p class="mb-0">{{ 'subscription_products.no_products' | translate }}</p>
              </div>
            </div>

          </div>
        </div>
              


      </div>
    </div>  

  </div>



















  

</div>



<div class="fixed-bottom">
  <div class="bg-white pt-3 pb-3">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-6">
          <h5 class="my-2">
            <span class="divSummaryTotal py-1 px-3">
              Total ({{cartCount}} produk): <b>IDR {{ getProRatedTotal() | number:'1.2-2' }}</b>
            </span>
            <sup><i class="ps-2 bi bi-info-circle pointer" placement="top auto" ngbTooltip="Total harga dihitung otomatis sesuai paket pilihan Anda, termasuk penyesuaian harga jika Anda melakukan perubahan paket subscription."  container="body" triggers="click" [autoClose]="'outside'"></i></sup>
          </h5>
        </div>

        <div class="col-12 col-lg-6">
          <div class="d-flex justify-content-end">
            <div class="">
              <a href="/subscription-cart" class="btn cdbtn2 px-3">Lanjutkan Pesanan</a>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>